<template>
<div class="InteractionRollList">
    <div class="search_handle_box">
        <div class="left_box">
            <el-button @click="downExcel">导出EXCEL</el-button>
        </div>
        <div class="right_box">
            <div class="sign_time_box">
                <el-date-picker @focus="closeDetalisInfo" v-model="searchParams.times" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </div>
            <div style="width: 150px;">
                <el-input @focus="closeDetalisInfo" v-model="searchParams.signName" placeholder="参与人"></el-input>
            </div>
            <el-button @click="handleQuery" type="primary" plain>搜索</el-button>
        </div>
    </div>
    <div class="table_box">
        <el-table @row-click="tableRowClick" :data="tableData" style="width: 100%">
            <el-table-column prop="index" label="序号" align="center" width="120"></el-table-column>
            <el-table-column label="参与人" align="center" min-width="200">
                <template slot-scope="scope">
                    <div class="user_info_box">
                        <img :src="scope.row.logourl" alt="">
                        <span>{{scope.row.customername}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="datetime" label="参与时间" align="center" min-width="180"></el-table-column>
            <el-table-column prop="isinteracttext" label="是否互动" align="center"></el-table-column>
            <el-table-column prop="interacttime" label="互动时间" align="center" min-width="180"></el-table-column>
            <el-table-column label="操作" align="right">
                <template slot-scope="scope">
                    <span style="color: #439FFE;" v-if="scope.row">详情</span>
                </template>
            </el-table-column>
        </el-table>
        <page :total="total" ref="page" @getList="searchBtn"></page>
    </div>
    <div class="right_details_box bgc box-shadow" :class="showRollDetail ? 'show_helps_box' : 'hide_icon_box'" ref="helps">
        <div v-if="showRollDetail" class="show_helps show_icon" @click="showRollDetail = false"></div>
        <div class="title_box">
            <span>详情资料</span>
            <img @click="showRollDetail = false" :src="require('@/common/images/activeOperate/close_icon.png')" alt="">
        </div>
        <div class="details_info_box">
            <div class="box1">
                <img :src="listDetailsInfo.logourl === '' ? require('@/common/images/other/user.png') : listDetailsInfo.logourl" alt="">
                <div>
                    <p>{{listDetailsInfo.customername}}</p>
                    <p>参与时间：{{listDetailsInfo.datetime}}</p>
                    <p>是否互动：{{listDetailsInfo.isinteracttext}}</p>
                    <p v-if="listDetailsInfo.isinteract === 1">互动时间：{{listDetailsInfo.interacttime}}</p>
                </div>
            </div>
            <div class="box2">
                <p>详细信息</p>
                <p v-for="(item, index) in listDetailsInfo.objlist" :key="index"><span>{{item.colname}}</span><span>{{item.colvalue}}</span></p>
                <div v-if="listDetailsInfo.objlist.length === 0" class="no_info_box">
                    <img :src="require('@/common/images/other/noinfo.png')" alt="">
                    <span>当前暂无详细信息</span>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {getInteractEventRollList, getInteractEventRollDetail, exportInteractRollExcel} from 'api/operateToolApi'
import Page from 'base/page/page'
import {mapGetters, mapActions} from 'vuex'
import {dateFormat} from 'common/js/tools'
export default {
    name: 'InteractionRollList',
    data() {
        return {
            total: 0,
            searchParams: {
                signName: '',
                times: ''
            },
            tableData: [],
            showRollDetail: false, // 右侧名单详情显示隐藏
            oldInnerid: '',
            newInnerid: '',
            listDetailsInfo: {
                customername: '',
                datetime: '',
                interacttime: '',
                isinteract: '',
                isinteracttext: '',
                joinermobile: '',
                joinername: '',
                logourl: '',
                objlist: []
            }
        }
    },
    mounted() {
        this.searchBtn()
    },
    methods: {
        // 导出互动名单列表 Excel
        downExcel() {
            this.closeDetalisInfo()
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid,
                customername: this.searchParams.signName,
                begintime: '',
                endtime: ''
            }
            if (this.searchParams.times !== '') {
                params.begintime = this.searchParams.times[0]
                params.endtime = this.searchParams.times[1]
            }
            exportInteractRollExcel({
                data: params,
                success: data => {
                    this.setLoading(false)
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '互动名单列表' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                    this.$message.success('导出成功')
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 关闭右侧名单详情
        closeDetalisInfo() {
            this.showRollDetail = false
        },
        // 名单表格每一行点击查询名单详情
        tableRowClick(row, event, column) {
            this.oldInnerid = this.newInnerid
            this.newInnerid = row.innerid
            if (this.oldInnerid === this.newInnerid) {
                this.showRollDetail = !this.showRollDetail
            } else {
                this.showRollDetail = false
                this.findInteractEventRollDetail(row)
            }
        },
        // 获取名单详情
        findInteractEventRollDetail(val) {
            this.setLoading(true)
            var params = {
                innerid: val.innerid
            }
            getInteractEventRollDetail({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    this.listDetailsInfo = data.data
                    this.showRollDetail = true
                    // setTimeout(() => {
                    //     this.showRollDetail = true
                    // },50 )
                },
                error: data => {
                    console.log('error：', data)
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        // 分页及搜索
        handleQuery() {
            this.total = 0
            this.$refs.page.handleSizeChange(1)
        },
        // 搜索按钮
        searchBtn() {
            this.setLoading(true)
            if (this.searchParams.times === null) {
                this.searchParams.times = ''
            }
            var params = {
                eventinnerid: this.$route.query.eventinnerid,
                customername: this.searchParams.signName,
                begintime: '',
                endtime: ''
            }
            if (this.searchParams.times !== '') {
                params.begintime = this.searchParams.times[0]
                params.endtime = this.searchParams.times[1]
            }
            getInteractEventRollList({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    // setTimeout(() => {
                    // },50 )
                    this.closeDetalisInfo()
                },
                error: data => {
                    console.log('error：', data)
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        Page
    }
}
</script>

<style lang="scss" type="text/scss">
.InteractionRollList {
    font-family:PingFangSC-Regular,PingFang SC;
    .search_handle_box {
        display: flex;
        justify-content: space-between;
        .right_box {
            display: flex;
            .el-input__icon {
                line-height: 0px;
            }
            &>div {
                margin-right: 30px;
            }
            .sign_time_box {
                .el-date-editor .el-range-separator {
                    line-height: 24px;
                }
                .el-date-editor--daterange.el-input__inner {
                    width: 260px;
                }
            }
        }
    }
    .table_box {
        margin-top: 30px;
        .el-table th>.cell {
            font-weight: bold!important;
        }
        .el-table__empty-block {
            min-height: 360px;
        }
        .el-table__empty-text {
            box-sizing: border-box;
            line-height: 0px;
            padding-top: 150px;
        }
        .el-table__row {
            cursor: pointer;
        }
        .user_info_box {
            display: flex;
            align-items: center;
            // justify-content: center;
            img{
                width: 50px;
                height: 50px;
                border-radius: 50%;
                margin-right: 10px;
            }
            span{
                color: #409EFF;
            }
        }
    }
    .right_details_box{
        position: fixed;
        top: 50px;
        right: -398px;
        height: 95.5vh;
        width: 398px;
        z-index: 10;
        box-sizing: border-box;
        box-shadow:-2px 0px 6px 0px rgba(0,0,0,0.1);
        font-family:PingFangSC-Regular,PingFang SC;
        .show_helps{
            width: 12px;
            height: 50px;
            background-size:12px 50px !important;
            position: absolute;
            top: 46%;
            left: -12px;
            cursor: pointer;
            border-radius: 6px 0 0 6px;
        }
        .show_helps:hover{
            background-color: #ccc;
        }
        .show_icon{
            background-image: url('../../../common/images/other/show.png');
        }
        .title_box{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px;
            height: 52px;
            box-shadow: -2px 0px 6px 0px rgba(0,0,0,0.1);
            span{
                font-weight: bold;
                font-size: 15px;
            }
            img {
                width: 10px;
                height: 10px;
                cursor: pointer;
            }
        }
        .details_info_box {
            .box1 {
                display: flex;
                align-items: center;
                padding: 30px 20px 40px 20px;
                img {
                    width: 64px;
                    height: 64px;
                    border-radius: 100%;
                    margin-right: 28px;
                }
                div {
                    p{
                        color:#999999;
                        line-height:20px;
                    }
                    p:nth-of-type(1){
                        color: #333333;
                    }
                    p:nth-of-type(2){
                        margin-top: 8px;
                        margin-bottom: 8px;
                    }
                    p:nth-of-type(3){
                        margin-bottom: 8px;
                    }
                }
            }
            .box2 {
                padding: 0 20px;
                p{
                    display: flex;
                    line-height:20px;
                    color: #333333;
                    margin-top: 20px;
                    span:nth-of-type(1){
                        line-height:20px;
                        color:#999999;
                        width: 120px;
                        min-width: 120px;
                        white-space: nowrap;
                    }
                    span:nth-of-type(2){
                        line-height:20px;
                    }
                }
                p:nth-of-type(1){
                    margin-top: 0px;
                    border-bottom: solid 1px #E5E5E5;
                    padding: 8px 0;
                    font-weight: bold;
                    font-size: 15px;
                }
                .no_info_box {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    padding: 30px 0;
                    span {
                        margin-top: 10px;
                        color:#999999;
                    }
                }
            }
        }
    }
    .show_helps_box{
        right: 0;
        transition: 0.5s all;
    }
    .hide_icon_box{
        right: -398px;
        transition: 0.5s all;
    }
}
</style>